import type { ColorKey } from 'components/utils/styles/types';

import * as styled from './styles';

type ProgressBarProps = {
  className?: string;
  progress: number;
  hasLabel?: boolean;
  barStyle?: 'default' | 'thin';
  fillColor: ColorKey;
  fillStyle?: 'default' | 'striped';
  bordered: boolean;
  labelColor: ColorKey;
  labelSize: number;
  barWidth: string;
};

export const ProgressBar = (props: ProgressBarProps) => {
  const {
    className,
    hasLabel = true,
    progress = 0,
    barStyle = 'default',
    fillColor = 'greenLight',
    fillStyle = 'default',
    bordered = false,
    labelColor = 'teal',
    labelSize = 2,
    barWidth = '100%',
  } = props;

  return (
    <styled.ProgressBar className={className}>
      {hasLabel && (
        <styled.Label labelColor={labelColor} labelSize={labelSize}>
          {Math.round(progress)}%
        </styled.Label>
      )}
      <styled.BarWrapper
        barStyle={barStyle}
        bordered={bordered}
        barWidth={barWidth}
      >
        <styled.Fill
          progress={progress}
          fillColor={fillColor}
          fillStyle={fillStyle}
          bordered={bordered}
        />
        <styled.Bar barStyle={barStyle} />
      </styled.BarWrapper>
    </styled.ProgressBar>
  );
};
